"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import { memo, useState } from "react";
import Markdown from "./markdown";
import equal from "fast-deep-equal";
import { cn } from "@/lib/utils";
import { CheckIcon, CopyIcon, EllipsisIcon, LoaderIcon,
// PencilIcon,
ThumbsDownIcon, ThumbsUpIcon } from "lucide-react";
import { PreviewAttachment } from "./preview-attachment";
import { MessageReasoning } from "./message-reasoning";
import { toast } from "sonner";
import useDelayedCopyTopClipboard from "@/hooks/use-delayed-copy-to-clipboard";
function MessageActionButton(t0) {
  const $ = _c(12);
  let Icon;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      Icon,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = className;
    $[3] = props;
  } else {
    Icon = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("size-8 flex disabled:opacity-50 disabled:pointer-events-none justify-center items-center cursor-pointer hover:bg-foreground/5 rounded-lg transition-all hover:text-foreground", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== Icon) {
    t2 = <Icon className="size-4.5" />;
    $[6] = Icon;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <button type="button" className={t1} {...props}>{t2}</button>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function CopyToClipboardButton(t0) {
  const $ = _c(7);
  const {
    message
  } = t0;
  const [isCopied, copyToClipboard] = useDelayedCopyTopClipboard(3000);
  const t1 = isCopied ? CheckIcon : CopyIcon;
  let t2;
  if ($[0] !== copyToClipboard || $[1] !== message.parts) {
    t2 = async () => {
      const textFromParts = message.parts?.filter(_temp).map(_temp2).join("\n").trim();
      if (!textFromParts) {
        toast.error("There's no text to copy!");
        return;
      }
      await copyToClipboard(textFromParts);
    };
    $[0] = copyToClipboard;
    $[1] = message.parts;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isCopied || $[4] !== t1 || $[5] !== t2) {
    t3 = <MessageActionButton disabled={isCopied} Icon={t1} onClick={t2} />;
    $[3] = isCopied;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp2(part_0) {
  return part_0.text;
}
function _temp(part) {
  return part.type === "text";
}
function VoteButton(t0) {
  const $ = _c(9);
  const {
    messageId,
    isUpvoted,
    type,
    setIsUpVoted
  } = t0;
  const t1 = type === "up" && isUpvoted === true || type === "down" && isUpvoted === false;
  const t2 = type === "up" ? ThumbsUpIcon : ThumbsDownIcon;
  let t3;
  if ($[0] !== isUpvoted || $[1] !== messageId || $[2] !== setIsUpVoted || $[3] !== type) {
    t3 = async () => {
      const newIsUpvoted = type === "up" && !isUpvoted ? true : type === "down" && isUpvoted == true || isUpvoted === null ? false : null;
      const upvote = fetch(`/api/message/${messageId}/vote`, {
        method: "POST",
        body: JSON.stringify({
          messageId,
          isUpvoted: newIsUpvoted
        })
      });
      toast.promise(upvote, {
        loading: "Voting Response...",
        success: () => {
          setIsUpVoted(newIsUpvoted);
          return "Voted Response!";
        },
        error: "Failed to vote response."
      });
    };
    $[0] = isUpvoted;
    $[1] = messageId;
    $[2] = setIsUpVoted;
    $[3] = type;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <MessageActionButton disabled={t1} Icon={t2} onClick={t3} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function AssistantMessageActions(t0) {
  const $ = _c(10);
  const {
    message,
    isUpvoted: initialIsUpVoted
  } = t0;
  const [isUpvoted, setIsUpVoted] = useState(initialIsUpVoted);
  let t1;
  if ($[0] !== message) {
    t1 = <CopyToClipboardButton message={message} />;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== isUpvoted || $[3] !== message.id) {
    t2 = <VoteButton isUpvoted={isUpvoted} type="up" messageId={message.id} setIsUpVoted={setIsUpVoted} />;
    t3 = <VoteButton isUpvoted={isUpvoted} type="down" messageId={message.id} setIsUpVoted={setIsUpVoted} />;
    $[2] = isUpvoted;
    $[3] = message.id;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex items-center text-[#7D7875] "><div className="flex items-center">{t1}{t2}{t3}</div></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
const PurePreviewMessage = t0 => {
  const $ = _c(25);
  const {
    message,
    isLoading,
    isUpvoted
  } = t0;
  const t1 = `message-${message.role}`;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      y: 5,
      opacity: 0
    };
    t3 = {
      y: 0,
      opacity: 1
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  const t4 = message.role;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("flex flex-col w-full bg-white rounded-2xl relative group-data-[role=user]/message:ml-auto group-data-[role=user]/message:max-w-2xl", "group-data-[role=user]/message:text-right");
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== message.role) {
    t6 = message.role === "assistant" && <div className="w-full px-6 pt-4 flex justify-between items-center"><div className="rounded-full border border-black/33 shadow bg-white text-sm px-3 py-0.5 w-max">Prompt title goes here</div><button type="button" className="cursor-pointer text-[#7D7875] hover:text-foreground size-6 hover:bg-foreground/5 rounded-xl flex justify-center items-center transition-all"><EllipsisIcon className="size-4.5" /></button></div>;
    $[3] = message.role;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== message.experimental_attachments) {
    t7 = message.experimental_attachments && message.experimental_attachments.length > 0 && <div data-testid="message-attachments" className="flex flex-row justify-end gap-2">{message.experimental_attachments.map(_temp3)}</div>;
    $[5] = message.experimental_attachments;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== isLoading || $[8] !== message.id || $[9] !== message.parts) {
    t8 = message.parts?.map((part, index) => {
      const {
        type
      } = part;
      const key = `message-${message.id}-part-${index}`;
      if (type === "reasoning") {
        return <MessageReasoning key={key} isLoading={isLoading} reasoning={part.reasoning} />;
      }
      if (type === "text") {
        return <div key={key} className="flex flex-row gap-2 items-start"><div className="py-4 px-6 prose"><Markdown>{part.text}</Markdown></div></div>;
      }
    });
    $[7] = isLoading;
    $[8] = message.id;
    $[9] = message.parts;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className="flex flex-col gap-4 w-full">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isUpvoted || $[15] !== message) {
    t10 = message.role === "assistant" && <div className="bg-white rounded-b-2xl w-full px-6 pb-4 flex justify-between items-center"><AssistantMessageActions message={message} isUpvoted={isUpvoted} /></div>;
    $[14] = isUpvoted;
    $[15] = message;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6 || $[19] !== t9) {
    t11 = <div className="w-full bg-[linear-gradient(180deg,rgba(0,0,0,0.22)_50%,rgba(0,0,0,0.44)_100%)] p-[1px] rounded-2xl"><div className={t5}>{t6}{t9}{t10}</div></div>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== message.role || $[22] !== t1 || $[23] !== t11) {
    t12 = <AnimatePresence><motion.div data-testid={t1} className="w-full mx-auto max-w-xl group/message bg-white ring-4 ring-[#6969691A] rounded-2xl" initial={t2} animate={t3} data-role={t4}>{t11}</motion.div></AnimatePresence>;
    $[21] = message.role;
    $[22] = t1;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
export const PreviewMessage = memo(PurePreviewMessage, (prevProps, nextProps) => {
  if (prevProps.isLoading !== nextProps.isLoading) return false;
  if (prevProps.message.id !== nextProps.message.id) return false;
  // if (prevProps.requiresScrollPadding !== nextProps.requiresScrollPadding)
  //   return false;
  if (!equal(prevProps.message.parts, nextProps.message.parts)) return false;
  if (!equal(prevProps.isUpvoted, nextProps.isUpvoted)) return false;
  return true;
});
export const ThinkingMessage = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      y: 5,
      opacity: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      y: 0,
      opacity: 1,
      transition: {
        delay: 1
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex gap-4 group-data-[role=user]/message:px-3 w-full group-data-[role=user]/message:w-fit group-data-[role=user]/message:ml-auto group-data-[role=user]/message:max-w-2xl group-data-[role=user]/message:py-2 rounded-xl", {
      "group-data-[role=user]/message:bg-muted": true
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="size-8 flex items-center rounded-full justify-center shrink-0 border border-neutral-300 bg-neutral-100"><LoaderIcon className="text-neutral-600 size-5 animate-spin" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.div data-testid="message-assistant-loading" className="w-full mx-auto max-w-xl px-4 group/message min-h-96" initial={t0} animate={t1} data-role="assistant"><div className={t2}>{t3}<div className="flex flex-col gap-2 w-full"><div className="flex flex-col gap-4 text-neutral-400">Thinking...</div></div></div></motion.div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
function _temp3(attachment) {
  return <PreviewAttachment key={attachment.url} attachment={attachment} />;
}